import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/logo_desktop.svg';
const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "mt-8 sm:mx-auto sm:w-full sm:max-w-md" };
const _hoisted_3 = { class: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" };
const _hoisted_4 = {
    key: 0,
    class: "mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded"
};
const _hoisted_5 = {
    key: 1,
    class: "mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded"
};
const _hoisted_6 = {
    key: 2,
    class: "space-y-6"
};
const _hoisted_7 = { class: "mt-1" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    key: 0,
    class: "mr-2"
};
const _hoisted_10 = {
    key: 3,
    class: "space-y-6"
};
const _hoisted_11 = { class: "mt-1" };
const _hoisted_12 = { class: "mt-2 text-sm text-gray-600" };
const _hoisted_13 = { class: "space-y-3" };
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
    key: 0,
    class: "mr-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"sm:mx-auto sm:w-full sm:max-w-md\"><div class=\"flex justify-center\"><img src=\"" + _imports_0 + "\" alt=\"TUK Logo\" class=\"h-8\"></div><h2 class=\"mt-6 text-center text-3xl font-bold text-gray-900\">Log ind</h2><p class=\"mt-2 text-center text-sm text-gray-600\">Brug dit telefonnummer for at logge ind</p></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                (_ctx.successMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.successMessage), 1))
                    : _createCommentVNode("", true),
                (!_ctx.codeSent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("label", {
                                for: "phone",
                                class: "block text-sm font-medium text-gray-700"
                            }, " Telefonnummer ", -1)),
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "phone",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.phoneNumber) = $event)),
                                    name: "phone",
                                    type: "tel",
                                    placeholder: "+45 12 34 56 78",
                                    class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-tuk-orange focus:border-tuk-orange sm:text-sm text-center"
                                }, null, 512), [
                                    [_vModelText, _ctx.phoneNumber]
                                ])
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "Indtast dit telefonnummer inklusiv landekode (+45 for Danmark)", -1))
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                disabled: _ctx.loading || !_ctx.phoneNumber,
                                class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-tuk-orange hover:bg-tuk-orange-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange disabled:opacity-50",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.sendCode && _ctx.sendCode(...args)))
                            }, [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[7] || (_cache[7] = [
                                        _createElementVNode("svg", {
                                            class: "animate-spin h-4 w-4",
                                            fill: "none",
                                            viewBox: "0 0 24 24"
                                        }, [
                                            _createElementVNode("circle", {
                                                class: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                "stroke-width": "4"
                                            }),
                                            _createElementVNode("path", {
                                                class: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true),
                                _cache[8] || (_cache[8] = _createTextVNode(" Send kode "))
                            ], 8, _hoisted_8)
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", {
                                for: "code",
                                class: "block text-sm font-medium text-gray-700"
                            }, " Bekræftelseskode ", -1)),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "code",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.verificationCode) = $event)),
                                    name: "code",
                                    type: "text",
                                    placeholder: "123456",
                                    maxlength: "6",
                                    class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-tuk-orange focus:border-tuk-orange sm:text-sm text-center"
                                }, null, 512), [
                                    [_vModelText, _ctx.verificationCode]
                                ])
                            ]),
                            _createElementVNode("p", _hoisted_12, "Indtast den 6-cifrede kode sendt til " + _toDisplayString(_ctx.phoneNumber), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                                disabled: _ctx.loading || !_ctx.verificationCode,
                                class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-tuk-orange hover:bg-tuk-orange-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange disabled:opacity-50",
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.verifyCode && _ctx.verifyCode(...args)))
                            }, [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[10] || (_cache[10] = [
                                        _createElementVNode("svg", {
                                            class: "animate-spin h-4 w-4",
                                            fill: "none",
                                            viewBox: "0 0 24 24"
                                        }, [
                                            _createElementVNode("circle", {
                                                class: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                "stroke-width": "4"
                                            }),
                                            _createElementVNode("path", {
                                                class: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true),
                                _cache[11] || (_cache[11] = _createTextVNode(" Bekræft "))
                            ], 8, _hoisted_14),
                            _createElementVNode("button", {
                                class: "w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange",
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                            }, " Tilbage ")
                        ])
                    ]))
            ])
        ])
    ]));
}
